import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { FaDownload, FaFileAlt, FaChartLine, FaArrowRight, FaExternalLinkAlt, FaInfoCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const DownloadsModule2 = () => {
  // Reset scroll position when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  const downloads = [
    {
      version: "9.0.65",
      date: "20 de septiembre de 2024",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_65_20240920_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.63",
      date: "19 de julio de 2024",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_63_20240719_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.61",
      date: "27 de marzo de 2024",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_61_20240327_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.56",
      date: "16 de febrero de 2024",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_56_20240216_v2022_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.53",
      date: "9 de febrero de 2024",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_53_20240209_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.47",
      date: "22 de enero de 2024",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_47_20240122_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.38",
      date: "29 de mayo de 2023",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_38_20230529_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.15",
      date: "17 de junio de 2022",
      liteSize: "175 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_15_20220617_Lite.zip",
      hasFullVersion: false
    },
    {
      version: "9.0.6",
      date: "10 de mayo de 2022",
      liteSize: "175 MB",
      fullSize: "650 MB",
      liteUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_6_20220510_Lite.zip",
      fullUrl: "https://www.ecosoft.com.mx/descargas/opus22/M2_2022_6_20220510_Full.zip",
      hasFullVersion: true
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Descargas OPUS 22 Módulo 2 | Ecosoft"
        description="Descargue las últimas versiones de OPUS 22 Módulo 2: Planeación y Control Integral."
        name="DownloadsModule2"
        type="website"
      />
      
      {/* Hero Section */}
      <section id="overview" className="relative h-[350px] bg-gradient-to-r from-[#003171] to-[#0066CC]">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="container mx-auto px-4 h-full flex items-center pt-12 relative z-10">
          <div className="max-w-2xl text-white">
            <h1 className="text-4xl font-bold mb-2">OPUS 22 - Módulo 2</h1>
            <h2 className="text-2xl font-semibold mb-4">Planeación y Control Integral</h2>
            <p className="text-lg mb-6">
              Descargue las últimas versiones del Módulo 2 de OPUS 22 para la planeación y control de sus proyectos.
            </p>
            <Link to="/downloads" className="inline-flex items-center text-white hover:underline">
              <FaArrowRight className="mr-2 rotate-180" /> Volver al Centro de Descargas
            </Link>
          </div>
        </div>
      </section>
      
      {/* Main Content */}
      <section className="py-12 px-6">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8">
            <div className="flex items-center mb-6">
              <div className="bg-[#0055B8]/10 p-3 rounded-full mr-4">
                <FaInfoCircle className="text-[#0055B8] text-2xl" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#1A2B39]">Información importante</h2>
                <p className="text-gray-600">Sobre las descargas de OPUS 22 - Módulo 2</p>
              </div>
            </div>
            
            <div className="mb-6 text-gray-700">
              <p className="mb-4">
                <strong>¿Qué revisión debo descargar?</strong>
              </p>
              <p className="mb-4">
                OPUS se adquiere bajo un esquema de suscripción, con fecha de caducidad. Esto quiere decir que puedes trabajar con revisiones con fecha de publicación igual o anterior a la fecha de caducidad de tu suscripción.
              </p>
              <p className="mb-4">
                La siguiente lista despliega todas las revisiones publicadas hasta el momento. Descarga e instala la revisión más reciente cuya fecha sea menor o igual a la fecha de caducidad de tu suscripción.
              </p>
              <p>
                El Módulo 2 de OPUS 22 te permite llevar un control detallado de la planeación de tus proyectos, facilitando la programación de actividades, asignación de recursos y seguimiento de avances.
              </p>
            </div>
          </div>
          
          {/* Downloads Section */}
          <h2 className="text-3xl font-bold mb-6 text-[#1A2B39]">Descargas disponibles</h2>
          
          <div className="mb-12">
            <div className="overflow-hidden rounded-lg shadow">
              <table className="w-full">
                <thead>
                  <tr className="bg-[#0055B8] text-white">
                    <th className="px-6 py-4 text-left">Revisión</th>
                    <th className="px-6 py-4 text-left">Fecha</th>
                    <th className="px-6 py-4 text-left">Descargas</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {downloads.map((download, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap font-semibold">
                        {download.version}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {download.date}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex flex-wrap gap-3">
                          <a 
                            href={download.liteUrl} 
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center px-4 py-2 bg-[#0055B8] text-white rounded hover:bg-[#003a80] transition-colors"
                          >
                            <FaDownload className="mr-2" /> Descarga Lite ({download.liteSize})
                          </a>
                          
                          {download.hasFullVersion && (
                            <a 
                              href={download.fullUrl} 
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-flex items-center px-4 py-2 bg-[#1A2B39] text-white rounded hover:bg-[#0d1824] transition-colors"
                            >
                              <FaDownload className="mr-2" /> Descarga Completa ({download.fullSize})
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="text-sm text-gray-600 mt-3">
              * Descarga e instala el paquete Lite si ya tienes instalado OPUS MÓDULO 2 en versión 21 ó la versión de lanzamiento de OPUS22.
            </p>
          </div>
          {/* Features Section */}
          <h2 className="text-3xl font-bold mb-6 text-[#1A2B39]">Características principales</h2>
          
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-[#0055B8]">Planeación de proyectos</h3>
              <p className="mb-4 text-gray-600">
                Crea programas detallados de obra con diagramas de Gantt, redes de actividades y rutas críticas que te permitirán visualizar la estructura completa de tu proyecto.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-[#0055B8]">Control de avances</h3>
              <p className="mb-4 text-gray-600">
                Realiza un seguimiento preciso del avance real vs. programado, con herramientas gráficas y analíticas que facilitan la toma de decisiones oportunas.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-[#0055B8]">Gestión de recursos</h3>
              <p className="mb-4 text-gray-600">
                Administra eficientemente los recursos de tu proyecto, con histogramas y curvas de recursos que te ayudarán a optimizar su distribución a lo largo del proyecto.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-[#0055B8]">Reportes avanzados</h3>
              <p className="mb-4 text-gray-600">
                Genera informes detallados y personalizables para diferentes niveles de gestión, facilitando la comunicación con clientes, directivos y equipos de trabajo.
              </p>
            </div>
          </div>
          
          {/* Additional Resources */}
          <h2 className="text-3xl font-bold mb-6 text-[#1A2B39]">Recursos adicionales</h2>
          
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-[#0055B8]">Guías y manuales</h3>
              <p className="mb-4 text-gray-600">
                Para obtener un manual actualizado, envíanos un correo a sgarcia@ecosoft.com.mx desde tu cuenta de correo asociada a tu suscripción vigente.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-[#0055B8]">Soporte técnico</h3>
              <p className="mb-4 text-gray-600">
                Si necesitas ayuda con la instalación o uso de OPUS, ponte en contacto con nuestro equipo de soporte técnico.
              </p>
              <p className="text-[#0055B8] font-bold">
                WhatsApp Soporte: (55) 7965.8522
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DownloadsModule2; 